// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PatientEmploymentResponse } from './patient-employment-response';

// @ts-ignore
import { ReferenceDataResponse } from './reference-data-response';

/** See com.rev360.pms.api.controller.patient.PatientQuickViewResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientQuickViewResponse extends GandalfModelBase {

	@GandalfArray(ReferenceDataResponse)
	categories!: ReferenceDataResponse[];

	@GandalfProperty({ designType: ReferenceDataResponse })
	dominantEye!: ReferenceDataResponse | null;

	@GandalfProperty({ designType: ReferenceDataResponse })
	dominantHand!: ReferenceDataResponse | null;

	@GandalfProperty({ designType: String })
	driversLicense!: string | null;

	@GandalfProperty({ designType: PatientEmploymentResponse })
	employment!: PatientEmploymentResponse | null;

	@GandalfProperty({ designType: String })
	patientComment!: string | null;

	@GandalfProperty({ designType: Number })
	patientPhotoId!: number | null;

}
